import { motion } from "framer-motion";
import Grid from "../Grid/grid";
import img1 from "../../Assets/image/image (1).webp";
import img2 from "../../Assets/image/clutch.webp";
import img3 from "../../Assets/image/research-partner-badge.svg";
import img4 from "../../Assets/image/image (4).webp";
import img5 from "../../Assets/image/image (3).webp";
import banner from "../../Assets/image/Collab-bro.webp";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

function HeroSection() {
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
  };

  const logos = [
    { img: img1, url: "https://softcodingsolutions.com/" },
    {
      img: img2,
      url: "https://clutch.co/profile/softcoding-solutions?_gl=1*15eqwr6*_gcl_au*MzE0NjAzNzAxLjE3NDA5ODU4Nzg.*_ga*MTMwMjY3NTkwMi4xNzQwOTg1ODc4*_ga_D0WFGX8X3V*MTc0MDk4NTg3Ny4xLjAuMTc0MDk4NTg4NS41Mi4wLjEzMDY0NTk5MzQ.#reviews",
    },
    {
      img: img3,
      url: "https://www.goodfirms.co/resources/why-apps-ask-permissions-know-data-control",
    },
    {
      img: img5,
      url: "https://www.goodfirms.co/",
    },
    { img: img4, url: "https://businessfirms.co/company/softcoding-solutions" },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <Grid direction="top-center" size={100} />

      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16 relative z-10 pt-40 md:pt-20">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <motion.div
            className="flex-1 text-center lg:text-center"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            <motion.h1
              variants={itemVariants}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 leading-[1.2] mb-6 max-w-4xl mx-auto text-center"
            >
              Building digital products <br />
              <span className="font-serif italic text-slate-500 text-xl sm:text-2xl md:text-3xl block my-0.5">with</span>
              <span className="font-bold text-primary md:whitespace-nowrap">Engineering excellence</span>
            </motion.h1>

            {/* <motion.p
              variants={itemVariants}
              className="text-lg sm:text-xl text-slate-600 mb-8 max-w-2xl mx-auto lg:mx-0 font-light leading-relaxed"
            >
              We transform complex challenges into seamless digital experiences.
              Let's make it real with scalable, high-performance software that
              drives your business forward.
            </motion.p> */}

            <motion.div
              variants={itemVariants}
              className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12"
            >
              <motion.button
                onClick={() => navigate("/contact-us")}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="group relative px-8 py-4 bg-primary text-white rounded-full font-medium overflow-hidden shadow-lg shadow-primary/20 hover:shadow-primary/30 transition-all duration-300"
              >
                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" />
                <span className="relative flex items-center gap-2">
                  Start Your Project
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </motion.button>
            </motion.div>

            <motion.div
              variants={itemVariants}
              className="border-t border-slate-100 pt-8"
            >
              <p className="text-sm text-slate-400 font-medium mb-4 uppercase tracking-wider">
                Trusted by Industry Leaders
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start items-center gap-6 sm:gap-8 opacity-90 transition-all duration-500">
                {logos.map((logo, index) => (
                  <a
                    key={index}
                    href={logo.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-transform hover:-translate-y-1 duration-300"
                  >
                    <img
                      src={logo.img}
                      alt="Partner Logo"
                      className="h-10 sm:h-20 w-auto object-contain"
                    />
                  </a>
                ))}
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            className="flex-1 relative"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
          >
            <img
              src={banner}
              alt="Collaboration and Development"
              className="w-full h-auto max-w-[600px] mx-auto drop-shadow-2xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
